module.exports = __webpack_public_path__ + "img/student3.943f7858.png";